const errorMessage_he = async (errorCode, requestContent) => {

    const message = {
        success: 'הצלחה!',
        error: 'שגיאה!',
        warning: 'אזהרה!',
        authUser: 'המשתמש אינו מאומת.',
        bannerSetting: 'שינויים בכותרת הבאנר עודכנו!',
        docVerify: 'סטטוס המסמכים השתנה!',
        cancelInfo: 'שינויים במידע הביטול עודכנו!',
        addWishlist: 'רשימת המשאלות נוספה בהצלחה.',
        updateWishList: 'רשימת המשאלות עודכנה בהצלחה,',
        cancelInfoError: 'שינויים במידע הביטול נכשלו',
        bannerSettingError: 'עדכון הגדרות הבאנר נכשל',
        verifyPhoneNumber: 'מספר הטלפון אומת בהצלחה.',
        validateNumber: 'לא הצלחנו לאמת את מספר הטלפון שלך. אנא נסה שוב',
        isListingAvailable: 'הרישום אינו זמין',
        cardError: 'מצטערים, משהו השתבש עם הכרטיס שלך. אנא נסה שוב.',
        requestError: 'בקשה לא חוקית',
        birthDayField: 'שדה יום הולדת חסר',
        birthYearField: 'שדה שנת לידה חסר',
        birthMonthField: 'שדה חודש לידה חסר',
        noRecord: 'לא נמצאו רשומות.',
        createFailed: 'יצירה נכשלה',
        addPopularLocation: 'המיקום נוסף בהצלחה!',
        invalidUrl: 'כתובת האתר כבר קיימת!',
        addBlogDetails: 'דף התוכן נוצר בהצלחה!',
        updateBlogDetails: 'דף התוכן עודכן בהצלחה!',
        isUpdated: 'לא עודכן',
        zipCode: 'קוד ה-ZIP שלך אינו מלא.',
        updateConfigSettings: 'ההגדרות עודכנו בהצלחה!',
        inActivePayment: "לא ניתן להשבית סוג תשלום זה מכיוון שהוא נמצא בשימוש כרגע.",
        isAllow: 'לפחות אפשרות אחת חייבת להיות פעילה.',
        noAccountExist: 'לא קיים חשבון עבור כתובת האימייל שסופקה.',
        userBanStatus: 'אופס! נראה שהחשבון שלך מושבת כרגע. אנא צור קשר עם התמיכה שלנו.',
        isExistAdminRole: 'מצטערים, לא ניתן למצוא את תפקיד המנהל הזה.',
        adminUser: 'אופס! לא ניתן למחוק את תפקיד המנהל מכיוון שהוא נמצא בשימוש על ידי משתמש מנהל כלשהו.',
        updateReview: "אופס! משהו השתבש. לא ניתן היה לעדכן את הביקורת. אנא נסה שוב מאוחר יותר.",
        findActiveReservation: 'אופס! לא ניתן למחוק את המשתמש הזה. נראה שלמשתמש יש הזמנות פעילות/עתידיות והוא צריך לבטל או להשלים את ההזמנות כדי למחוק אותם.',
        adminLogin: 'אופס! אנא התחבר כמשתמש מנהל ונסה שוב.',
        fetchRecord: "משהו השתבש באחזור הרשומות. אנא נסה שוב.",
        loginError: 'אתה לא מחובר, אנא התחבר ונסה שוב!',
        createListPhoto: 'תמונת הרשימה שלך הועלתה בהצלחה!',
        removeListPhoto: 'לא ניתן להסיר תמונות מכיוון שיש לך הזמנות או פניות עתידיות עבור רשימה זו.',
        resendVerifyEmail: 'קישור לאימות נשלח לכתובת האימייל שלך.',
        resentEmailError: 'שליחת האימייל נכשלה. אנא נסה שוב מאוחר יותר',
        upcomingBooking: 'מצטערים, לא ניתן למחוק נכס זה, יש לו הזמנות או פניות עתידיות.',
        invalidAddress: 'נראה שהכתובת שלך לא חוקית, אנא חזור לערוך את הכתובת שלך!',
        holdPayoutSuccess: 'סטטוס החזקת התשלום עודכן בהצלחה.',
        holdPayoutError: 'שינוי סטטוס החזקת התשלום נכשל',
        paypalError: "המטבע שבחרת אינו נתמך על ידי PayPal לתשלום. אנא שנה את המטבע ונסה לבצע את התשלום שוב.",
        forgotPasswordLink: 'קישור לאיפוס הסיסמה נשלח לכתובת האימייל שלך.',
        changeForgotPassword: 'הסיסמה שלך שונתה. כעת תוכל לנסות להתחבר.',
        deleteCalendar: `לוח השנה המסונכרן "${requestContent}" נמחק בהצלחה.`,
        deleteCalendarError: `מחיקת היומן המסונכרן נכשלה "${requestContent}".`,
        importCalendar: 'היומן נוסף בהצלחה! תהליך הסנכרון של היומן התחיל!',
        existImportCalendar: 'היומן שלך כבר יובא!',
        invalidCalendar: 'יומן לא חוקי! הכתובת שגויה, וייבוא היומן נכשל.',
        unPublish: 'לא ניתן לבטל פרסום מכיוון שיש לך הזמנות או פניות עתידיות עבור רשימה זו.',
        createListing: 'הרשימה שלך נשלחה לאישור',
        actionFailed: 'פעולה נכשלה!',
        listApprovalStatus: 'בקשת הסקירה של הרשימה נדחתה בהצלחה.',
        listingApprove: 'הרשימה אושרה בהצלחה!',
        contactHostError: 'כבר ביקשת בתאריך זה',
        contactHost: 'הבקשה שלך נשלחה!',
        sendMessageError1: 'אופס! כבר ביצעת פעולה זו!',
        sendMessageError2: 'אופס! כבר אישרת זאת למשתמש אחר',
        cancelReservation: 'ההזמנה בוטלה בהצלחה',
        cancelReservationError: 'נראה שההזמנה שלך כבר עודכנה!',
        paymentToHost: 'התשלום הועבר למארח בהצלחה!',
        paymentToHostError: 'התשלום למארח נכשל, אנא נסה שוב עם מטבע אחר',
        refundToGuest: 'התשלום הועבר לאורח בהצלחה!',
        refundToGuestError: 'התשלום לאורח נכשל, אנא נסה שוב עם מטבע אחר',
        updateServiceFee: 'דמי השירות עודכנו בהצלחה!',
        updateServiceFeeError: 'עדכון דמי השירות נכשל..',
        deleteSuccess: 'נמחק בהצלחה.',
        deleteFailed: 'מחיקה נכשלה!',
        updateStatus: 'הסטטוס השתנה',
        updateFailed: 'שינוי הסטטוס נכשל',
        updatePopularLocation: 'סטטוס המיקום השתנה',
        updateLocationError: 'שינוי סטטוס המיקום נכשל',
        updateWhyHost: 'שינויים בדף "למה להיות מארח" עודכנו!',
        deleteListSetting: 'ההגדרה נמחקה בהצלחה',
        deleteSettingError1: 'לא ניתן למחוק את הגדרת הרשימה. לפחות, יש להשאיר הגדרת רשימה אחת זמינה עבור הנכסים.',
        deleteSettingError2: 'לא ניתן למחוק את הגדרת הרשימה. הגדרת הרשימה נמצאת בשימוש בנכס. אנא הסר את הגדרת הרשימה מהנכסים ונסה שוב.',
        addBanner: 'התמונה הועלתה בהצלחה!',
        updateBanner: 'השינויים עודכנו בהצלחה!',
        updateBanStatus: 'סטטוס המשתמש עודכן בהצלחה',
        updateBanError: 'עדכון סטטוס החסימה נכשל.',
        updateBanWarning: 'עליך לבחור באפשרות אחת מתוך אפשרויות האפשר/אסור',
        paymentGateway: 'הסטטוס עודכן בהצלחה!',
        updateStaticPage: 'דף התוכן הסטטי עודכן בהצלחה!',
        updateStaticPageError: 'עדכון דף התוכן הסטטי נכשל',
        deleteUser: 'המשתמש נמחק בהצלחה',
        deleteReview: 'הביקורת נמחקה בהצלחה',
        updateReview: 'הביקורת עודכנה בהצלחה!',
        deleteReviewError: 'מחיקת הביקורת נכשלה',
        deleteAdminRole: 'תפקיד המנהל נמחק בהצלחה',
        deleteAdminUser: 'משתמש המנהל נמחק בהצלחה',
        updatePolicy: 'המדיניות עודכנה בהצלחה!',
        disableBaseCurrency: "מצטערים, לא ניתן להשבית את המטבע הבסיסי. נסה להגדיר מטבע בסיס אחר ולהשבית את זה.",
        currencyStatus: 'סטטוס המטבע השתנה!',
        currencyStatusError: 'שינוי סטטוס המטבע נכשל',
        baseCurrency: 'המטבע הבסיסי הוגדר בהצלחה.',
        baseCurrencyError: 'הגדרת המטבע הבסיסי נכשלה',
        PaymentCurrency: 'שינויים במטבע התשלום בוצעו',
        PaymentCurrencyError: 'שינוי סטטוס מטבע התשלום נכשל',
        addRecommend: 'הרשימה נוספה לרשימה המומלצת',
        removeRecommend: 'הרשימה הוסרה מהרשימה המומלצת',
        fileTypeError: 'אתה מנסה להעלות קובץ תמונה לא חוקי. אנא העלה קובץ תמונה בפורמט PNG, JPG או JPEG.',
        limitError: 'גודל ההעלאה המקסימלי הופר! נסה עם תמונה בגודל קטן יותר.',
        isAdmin: "אתה מחובר כמנהל, לא ניתן לבצע פעולה זו!",
        updateFaq: 'שינויים ב-FAQ עודכנו!',
        updateFaqError: 'עדכון שינויים ב-FAQ נכשל.',
        updateWhyHostPage: 'שינויים בקטע הציטוט בדף "למה להיות מארח" עודכנו!',
        updateWhyHostError: 'עדכון הגדרות "למה להיות מארח" נכשל',
        updateHostPage: 'שינויים בבאנר בדף "למה להיות מארח" עודכנו!',
        updateHostPageError: 'שינויים בבאנר בדף "למה להיות מארח" נכשלו!',
        updateBlock4: 'הגדרות בלוק 4 ב"למה להיות מארח" עודכנו!',
        updateBlockError: 'עדכון הגדרות בלוק 4 ב"למה להיות מארח" נכשל',
        updateBlock3: 'הגדרות בלוק 3 ב"למה להיות מארח" עודכנו!',
        updateBlockError3: 'עדכון הגדרות בלוק 3 ב"למה להיות מארח" נכשל!',
        uploadImage: 'אנא העלה את התמונה!',
        updateBlock1: 'הגדרות בלוק 1 ב"למה להיות מארח" עודכנו!',
        updateBlockError1: 'עדכון הגדרות בלוק 1 ב"למה להיות מארח" נכשל!',
        approved: 'כבר אישרת',
        userReviewError: 'השינויים שלך לביקורת המנהל נכשלו!',
        invalidId: 'מזהה הרשימה אינו זמין',
        uploadBlockImage: 'אנא העלה את תמונת הבלוק!',
        updateStaticBlock: 'שינויים בהגדרות הבלוק הסטטי עודכנו',
        updateStaticError: 'שינויים בבלוק המידע הסטטי נכשלו!',
        updateSiteSettings: 'שינויים בהגדרות האתר עודכנו!',
        updateSettingsError: 'עדכון שינויים בהגדרות האתר נכשל!',
        updateSearchSettings: 'שינויים בהגדרות החיפוש עודכנו!',
        searchSettingError: 'עדכון הגדרות החיפוש נכשל',
        updatePayment: 'הגדרות התשלום עודכנו!',
        paymentSettingError: 'עדכון הגדרות התשלום נכשל',
        updateListSettings: 'הגדרת הרשימה עודכנה בהצלחה!',
        disableListSettings: 'לא ניתן להשבית את הגדרת הרשימה. לפחות, יש להשאיר הגדרת רשימה אחת פעילה.',
        listingUsed: 'לא ניתן להשבית את הגדרת הרשימה. הגדרת הרשימה נמצאת בשימוש בנכס. אנא הסר את הגדרת הרשימה מהנכסים ונסה שוב.',
        addListSettings: 'הגדרת הרשימה נוצרה בהצלחה!',
        addListingError: 'יצירת הגדרת הרשימה נכשלה.',
        commandReason: 'אנא הוסף סיבה חוקית.',
        alreadyApprove: 'כבר אישרת',
        footerSetting: 'שינויים בהגדרות התחתית עודכנו!',
        footerSettingError: 'שינויים בהגדרות התחתית נכשלו.',
        updateUser: 'שינויים בפרופיל עודכנו',
        addContent: 'אנא הוסף תוכן',
        addTitle: 'אנא הוסף כותרת מטא',
        addDescription: 'אנא הוסף תיאור מטא',
        uploadLocImage: 'אנא העלה תמונת מיקום',
        updateLocation: 'שינויים במיקום עודכנו!',
        updateLocationError: 'עדכון המיקום נכשל',
        adminRemoveListing: 'הרשימה הוסרה בהצלחה',
        sendEmail: 'האימייל שלך נשלח.',
        listSettingsData: 'אופס! לא ניתן למצוא את הגדרות הרשימה. אנא נסה שוב.',
        cancelBooking: 'כבר ביטלת את ההזמנה.',
        checkAvailableDates: 'התאריכים אינם זמינים!',
        isListingAvailable: 'הרשימה בוטלה או נמחקה על ידי המארח/מנהל. אנא צור קשר עם המנהל למידע נוסף.',
        checkUser: 'אופס! המשתמש שונה',
        updateCancelPolicy: 'משהו השתבש! לא ניתן היה לעדכן!',
        existEmail: 'אופס! כתובת האימייל הזו כבר קיימת.',
        invalidRoleId: 'אופס, נראה שהתפקיד שנבחר אינו חוקי. אנא נסה עם תפקיד חוקי אחר.',
        passwordMismatch: 'הסיסמה אינה תואמת. אנא נסה שוב.',
        changePassword: 'הסיסמה עודכנה בהצלחה!',
        wrongPassword: 'הסיסמה הנוכחית שגויה, נסה שוב!',
        wrongConfirmPassword: 'סיסמת האימות אינה תואמת לסיסמה החדשה!',
        invalidSpecPrice: 'המחיר המיוחד אינו חוקי',
        removeDocList: 'המסמך הוסר בהצלחה!',
        uploadDocument: 'המסמך שלך הועלה בהצלחה!',
        missingField: 'נראה ששכחת למלא שדות חובה. אנא מלא אותם.',
        ageLimit: 'מצטערים, אתה חייב להיות מעל גיל 18',
        invalidDob: 'תאריך לידה לא חוקי, אנא מלא את הנתונים הנכונים',
        changeAdminUser: 'פרטי הגישה של המנהל שונו בהצלחה!',
        changeUserError: 'השינויים שלך לפרטי הגישה של המנהל נכשלו!',
        updateProfile: 'הפרופיל שלך עודכן בהצלחה.',
        invalidEmail: 'כתובת האימייל כבר קיימת, אנא נסה כתובת אימייל אחרת!',
        isPublished: 'אופס! לא ניתן להמליץ על רשימה שלא פורסמה.',
        sendSMTPEmail: 'אופס! משהו השתבש. לא ניתן לשלוח את האימייל.',
        stripeTokenError: 'אופס! לא ניתן להמשיך בפעולה המבוקשת. אנא נסה שוב.',
        otpError: 'אנא נסה שוב לאחר 2 דקות כדי לקבל OTP חדש.',
        pageReload: 'משהו השתבש, טען מחדש את הדף ונסה שוב.',
        userExist: 'מצטערים, המשתמש אינו קיים במסד הנתונים!',
        removeFiles: 'הקבצים הוסרו בהצלחה.',
        removeFilesError: 'הקבצים לא נמחקו.',
        templateMissing: 'נדרשת כתובת קבלה או סוג תבנית.',
        existFileName: 'שם הקובץ אינו קיים.',
        paymentCompleted: 'עבור הזמנה זו, התשלום כבר בוצע.',
        adminUserLogged: 'נראה שאתה כבר מחובר כמשתמש מנהל. אנא התנתק מלוח המנהל ונסה שוב.',
        ogImageError: 'אנא העלה את תמונת ה-OG.',
        offlineError: 'אתה במצב לא מקוון. אנא נסה שוב מאוחר יותר.',
        datesNotAvailable: 'התאריכים הללו אינם זמינים. אנא נסה שוב עם תאריכים שונים.',
        adminReviewError: 'לא ניתן להמליץ על רשימה זו כרגע מכיוון שהיא לא נוצרה במלואה.',
        isAgreePhoneNumberError: 'אנא סמן את תיבת הסימון לאימות SMS ושמור את הפרטים שלך.',
        updateEditProfile: 'השינויים עודכנו בהצלחה.',
        deleteAccountError: 'לא ניתן למחוק את החשבון שלך מכיוון שיש לך הזמנות פעילות.',
        deleteUserAccount: 'החשבון שלך נמחק בהצלחה.',
        smtpActiveStatus: 'הסטטוס עודכן בהצלחה!',
        deleteSmtpData: 'נתוני SMTP נמחקו בהצלחה.',
        deleteSmtpDataError: 'לא ניתן למחוק פרטי SMTP פעילים.',
        holdRefundSuccess: 'סטטוס החזקת ההחזר עודכן בהצלחה.',
        holdRefundError: 'שינוי סטטוס החזקת ההחזר נכשל.',
        hostServiceFeeGreater: 'לא ניתן להתחיל את ההזמנה עבור התאריכים שנבחרו עקב שגיאות תמחור. אנא צור קשר עם המנהל למידע נוסף.',
        addSmtpData: `נתוני SMTP נוספו בהצלחה!`,
        updatedSmtpData: `נתוני ה-SMTP עודכנו בהצלחה!`,
        writeAdminReview: `פרטי ביקורת המנהל ${requestContent ? 'עודכנו' : 'נשלחו'} בהצלחה!`,
        writeUserReview: `פרטי ביקורת המשתמש ${requestContent ? 'עודכנו' : 'נשלחו'} בהצלחה!`,
        addAdminRole: `תפקיד המנהל ${requestContent == 'add' ? 'הוסיף' : 'מְעוּדכָּן'} בהצלחה!`,
        catchError: `משהו השתבש! ${requestContent}`,
        publishSuccess: `הרשימה שלך ${requestContent == 'Publish Listing' ? 'פורסמה' : 'בוטלה פרסומה'} בהצלחה.`,
        commonError: requestContent || 'משהו השתבש. אנא נסה שוב מאוחר יותר',
        restrictStaticPageDisable: "מצטערים, אינך רשאי להשבית שדה זה.",
        payoutCurrencySuccess: 'מטבע התשלום עודכן בהצלחה',
        payoutCurrencyFailed: 'אינך רשאי לעדכן את מטבע התשלום המועדף',
        cantDisablePayoutCurrency: 'אינך יכול להשבית מטבע זה מכיוון שהוא מטבע התשלום המועדף. אנא הגדר מטבע אחר כמטבע התשלום המועדף לפני השבתת מטבע זה',
        checkTermsAndPolicy: `אנא אשר את תנאי השירות ומדיניות הפרטיות כדי להמשיך.`,
        documentsApproved: `המסמכים אושרו!`,
        documentsRejected: `המסמכים נדחו!`,
        accountDeleteError: `חשבונך נמחק בהצלחה. אנא צור קשר עם התמיכה לקבלת סיוע.`,
        accountBanError: `החשבון שלך נחסם על ידי מנהל המערכת. אנא צור קשר עם התמיכה לקבלת סיוע.`,
        demoWarning: `מצטערים, אינך רשאי לשנות או להסיר את פרטי ההדגמה.`,
        disableDemo: `פעולה זו מושבתת באתר ההדגמה.`,
        settingUpdateSuccess: `שינויי הגדרות האתר יושמו בהצלחה`,
        documentChangeWarning: `המסמכים אושרו ולא ניתן עוד לשנותם.`
    }
    return message[errorCode]

}
export default errorMessage_he;